<template>

    <form v-on:submit.prevent="create()" class="modal-card" style="min-width: 10em;">
        <header class="modal-card-head">
            <p class="modal-card-title">
                Create a Model 
            </p>
            <button
                type="button"
                class="delete"
                @click="$emit('close')"/>
        </header>
        <section class="modal-card-body">
            <b-field label="Model name">
                <b-input
                    type="My Model"
                    v-model="modelName"
                    placeholder="Model name"
                    required>
                </b-input>
            </b-field>
    
            <b-field label="Model type (Only text classification)">
                
                <b-radio v-model="modelType"
                    native-value="binary">
                    Binary Classification
                </b-radio>
                <b-radio v-model="modelType"
                    native-value="multiclass">
                    Multi-class Classification
                </b-radio>
            </b-field>
    
            <!--b-field label="Training">
                <b-input
                    type="text"
                    v-model="trainingModels"
                    placeholder="Nr. of models"
                    required>
                </b-input>
            </b-field-->
    
            <b-field label="Datasets">
                <p>Your dataset will be splited between training and evaluation sets.</p>
            </b-field>
            <b-field>
                <b-select
                    v-model="selectedDataset"
                    style="min-width: 100%;"
                    required
                    >
                    <option v-for="d in [datasetData]"
                    :key="d.id"
                    :value="d.id">
                    <span v-if="d.public">
                        Demo - 
                    </span>
                    {{ d.name }}
                    ({{ d.instances }} instances and
                    {{ d.tokens }} tokens)
                    
    
                    </option>
                </b-select>
            </b-field>
        </section>
        <footer class="modal-card-foot">
            <b-button
                label="Close"
                @click="$emit('close')" />
            <b-button
                tag="button"
                native-type="submit"
                label="Create"
                type="is-primary"
                expanded />
        </footer>
    </form>
    </template>
    <script>
    import { uuid } from 'vue-uuid'; 
    
    export default {
       props: ["datasetData"],
      data() {
        return {
          radio: 'binary',
          dataset: null,
          modelName: '',
          modelType: 'binary',
          trainingModels: 2,
          isFinished: false,
          selectedDataset: []
        };
      },
      created() {
         this.$store.dispatch("retrievePublicDatasets");
         this.$store.dispatch("retrieveAllDatasets");
    
         this.selectedDataset = [this.datasetData.id]
         this.modelName = (this.datasetData!=undefined)?this.datasetData.name+' Model':''
      },
      computed: {
        datasets() {
            return [...this.$store.state.datasets, ...this.$store.state.publicDatasets]
        }
      },
      methods: {
            openLoading() {
                    let isFullPage = true
                    const loadingComponent = this.$buefy.loading.open({
                        container: isFullPage ? null : this.$refs.element.$el
                    })
                    setTimeout(() => loadingComponent.close(), 5 * 1000)
            },
            create() {
    
                this.$buefy.notification.open('Creating the model ' + this.modelName)
                
                this.modelId = uuid.v4()
    
                this.isFinished = true
                
                this.openLoading()
    
                this.createModel()
    
               },
               createModel() {
    
                    const model = {
                        type: this.modelType,
                        data_source: "data_source",
                        train_type: "train_type",
                        name: this.modelName,
                        datasets: this.selectedDataset,
                        is_training: true
                    }
    
                    var newDoc = this.$store.dispatch("createModel",
                        model
                    );
    
                    newDoc.then(newModelId => {
                        setTimeout(() => 
                            this.$router.push('/models/'+newModelId+'/training'), 
                        2.2 * 1000)
                    })
    
                    
                    
               }
        },
        
    }
    </script>